<app-layout>
  <app-page-header
    [title]="'Minhas vendas'"
    [titleIcon]="'pi pi-wallet'"
    [subtitle]="'Consulte as vendas realizadas por evento e acompanhe status de pagamento.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Eventos para venda', link: '/seller-events', icon: 'pi pi-shopping-cart' },
      { label: 'Minhas vendas', icon: 'pi pi-wallet' },
    ]"></app-page-header>

  <div class="seller-orders container-fluid p-4">
    <section class="seller-orders__filters card">
      <header class="seller-orders__filters-header">
        <div>
          <h2 class="seller-orders__filters-title">Filtros</h2>
          <p class="seller-orders__filters-subtitle">
            Refine suas vendas por evento, intervalo de data e número do pedido.
          </p>
        </div>
        <app-button
          styleType="secondary"
          class="seller-orders__collapse-btn"
          [icon]="isFiltersCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
          [attr.aria-expanded]="!isFiltersCollapsed"
          aria-controls="seller-orders-filters-content"
          (btnClick)="toggleFilters()">
          {{ isFiltersCollapsed ? "Mostrar filtros" : "Ocultar filtros" }}
        </app-button>
      </header>

      @if (!isFiltersCollapsed) {
        <div id="seller-orders-filters-content" class="seller-orders__filters-grid">
          <div class="seller-orders__filter-field">
            <label for="eventFilter" class="form-label">Evento</label>
            <select id="eventFilter" class="form-select" [(ngModel)]="filterForm.event_id">
              <option [ngValue]="undefined">Todos os eventos</option>
              @for (event of events; track event.id) {
                <option [ngValue]="+event.id">{{ event.title }}</option>
              }
            </select>
          </div>

          <div class="seller-orders__filter-field">
            <label for="initialDateFilter" class="form-label">Data inicial</label>
            <p-datepicker
              appDatepickerMask
              inputStyleClass="form-control seller-orders__date-input"
              class="w-100 seller-orders__date-picker"
              id="initialDateFilter"
              inputId="initialDateFilter"
              [(ngModel)]="filterForm.initial_date"
              [showIcon]="true"
              [appendTo]="'body'"
              [iconDisplay]="'input'"
              [maxDate]="filterForm.final_date"
              [showTime]="false"
              [hourFormat]="'24'" />
          </div>

          <div class="seller-orders__filter-field">
            <label for="finalDateFilter" class="form-label">Data final</label>
            <p-datepicker
              appDatepickerMask
              inputStyleClass="form-control seller-orders__date-input"
              class="w-100 seller-orders__date-picker"
              id="finalDateFilter"
              inputId="finalDateFilter"
              [(ngModel)]="filterForm.final_date"
              [showIcon]="true"
              [appendTo]="'body'"
              [iconDisplay]="'input'"
              [minDate]="filterForm.initial_date"
              [showTime]="false"
              [hourFormat]="'24'" />
          </div>

          <div class="seller-orders__filter-field">
            <label for="orderNumberFilter" class="form-label">Número do pedido</label>
            <input
              id="orderNumberFilter"
              class="form-control"
              type="text"
              inputmode="numeric"
              placeholder="Ex.: 10245"
              [(ngModel)]="filterForm.order_number" />
          </div>

          <!-- <div class="seller-orders__checkbox">
            <input
              id="includeQr"
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="filterForm.include_qr" />
            <label for="includeQr" class="form-check-label">Incluir QR Code dos ingressos</label>
          </div> -->

          <div class="seller-orders__filters-actions">
            <app-button styleType="outlined" [disabled]="!hasActiveFilters" (btnClick)="clearFilters()">
              Limpar filtros
            </app-button>
            <app-button [disabled]="hasInvalidDateRange" (btnClick)="applyFilters()"> Aplicar filtros </app-button>
          </div>
        </div>

        @if (hasInvalidDateRange) {
          <p class="seller-orders__filters-error">A data final deve ser maior ou igual a data inicial.</p>
        }
      }
    </section>

    @if (loading) {
      <div class="seller-orders__skeleton-grid">
        <p-skeleton height="180px" />
        <p-skeleton height="180px" />
        <p-skeleton height="180px" />
      </div>
    } @else if (errorMessage) {
      <div class="seller-orders__empty seller-orders__empty--error">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <p>{{ errorMessage }}</p>
      </div>
    } @else if (orders.length === 0) {
      <div class="seller-orders__empty">
        <i class="pi pi-inbox" aria-hidden="true"></i>
        <p>Nenhuma venda encontrada para os filtros informados.</p>
      </div>
    } @else {
      <div class="seller-orders__list">
        @for (order of orders; track trackOrder($index, order)) {
          <article class="seller-orders__card card">
            <header class="seller-orders__card-header">
              <div>
                <p class="seller-orders__order-id">Pedido #{{ order.id }}</p>
                <p class="seller-orders__customer">{{ formatCustomer(order) }}</p>
              </div>
              <span class="seller-orders__status" [ngClass]="getPaymentStatusClass(order.payment_status)">
                {{ order.payment_status | orderPaymentStatus }}
              </span>
            </header>

            <div class="seller-orders__card-grid">
              <div>
                <small>Método</small>
                <p>{{ order.payment_method | paymentMethod }}</p>
              </div>
              <div>
                <small>Total</small>
                <p>{{ order.total_amount | currency: "BRL" }}</p>
              </div>
              <div>
                <small>Pagamento</small>
                <p>{{ order.paid_at | date: "dd/MM/yyyy HH:mm" }}</p>
              </div>
              <div>
                <small>Ingressos</small>
                <p>{{ order.tickets.length }}</p>
              </div>
            </div>

            <div class="seller-orders__actions">
              <app-button styleType="outlined" (btnClick)="openOrderDetails(order)">
                <i class="pi pi-eye me-2"></i>
                Detalhes do pedido
              </app-button>
            </div>
          </article>
        }
      </div>

      <p-paginator
        [rows]="filters.per_page"
        [first]="paginatorFirst"
        [totalRecords]="meta.total_count"
        [rowsPerPageOptions]="perPageOptions"
        (onPageChange)="onPageChange($event)" />
    }
  </div>
</app-layout>
